export const methods = {
  get: "get",
  post: "post",
  patch: "patch",
  delete: "delete",
};
